export const firebaseConfig = {
  apiKey: "AIzaSyDmvkwEp-bINWiK5qZZREovn8SpYCJywh0",
  authDomain: "prezcall2.firebaseapp.com",
  databaseURL: "https://prezcall2.firebaseio.com",
  projectId: "prezcall2",
  storageBucket: "prezcall2.appspot.com",
  messagingSenderId: "1017643555043",
  appId: "1:1017643555043:web:5aa1f834db22fb40d4cdd6"
};
